import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import CmsRichEditor from "../../components/RichEditor";

export default function CmsAdminForm() {
  const navigate = useNavigate();
  const { cms_page_id } = useParams();

  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);

  const [form, setForm] = useState({
    title: "",
    content: "",
    status: "1",
  });

  const fetchPage = async () => {
    try {
      setFetching(true);

      const res = await api.get(`/admin/cms-pages/${cms_page_id}`);
      const data = res.data?.data;

      setForm({
        title: data?.title || "",
        content: data?.content || "",
        status: String(data?.status ?? "1"),
      });
    } catch (e) {
      toast.error(e?.response?.data?.message || e.message || "Failed to load CMS page");
    } finally {
      setFetching(false);
    }
  };

  useEffect(() => {
    if (cms_page_id) fetchPage();
  }, [cms_page_id]);

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!form.title.trim() || !form.content.trim()) {
      toast.error("Title and content are required");
      return;
    }

    try {
      setLoading(true);

      if (cms_page_id) {
        await api.patch(`/admin/cms-pages/${cms_page_id}`, {
          title: form.title,
          content: form.content,
          status: Number(form.status),
        });
        toast.success("CMS page updated");
      } else {
        await api.post("/admin/cms-pages", {
          title: form.title,
          content: form.content,
          status: Number(form.status),
        });
        toast.success("CMS page created");
      }

      navigate("/admin/cms-pages");
    } catch (e) {
      toast.error(e?.response?.data?.message || e.message || "Save failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold">
            {cms_page_id ? "Edit CMS Page" : "Create CMS Page"}
          </h1>
        </div>

        <button
          type="button"
          className="rounded-xl border px-4 py-2 text-sm font-semibold hover:bg-gray-50 self-start"
          onClick={() => navigate("/admin/cms-pages")}
        >
          Back
        </button>
      </div>

      {fetching ? (
        <div className="mt-6 text-sm text-gray-600">Loading page...</div>
      ) : (
        <form onSubmit={onSubmit} className="mt-6 border rounded-2xl p-5 space-y-4">
          <div>
            <label className="text-sm font-semibold">Title</label>
            <input
              name="title"
              value={form.title}
              onChange={onChange}
              className="mt-2 w-full border rounded-xl px-3 py-2 outline-none focus:ring-2 focus:ring-black"
              placeholder="Ex: About Us"
            />
          </div>

          <div>
            <label className="text-sm font-semibold">Content</label>
            {/* <textarea
              name="content"
              value={form.content}
              onChange={onChange}
              rows={10}
              className="mt-2 w-full border rounded-xl px-3 py-2 outline-none focus:ring-2 focus:ring-black"
              placeholder="Write page content..."
            /> */}
              <div className="mt-2">
                <CmsRichEditor
                  value={form.content}
                  onChange={(html) => setForm((p) => ({ ...p, content: html }))}
                />
              </div>
          </div>

          <div className="max-w-[240px]">
            <label className="text-sm font-semibold">Status</label>
            <select
              name="status"
              value={form.status}
              onChange={onChange}
              className="mt-2 w-full border rounded-xl px-3 py-2 outline-none focus:ring-2 focus:ring-black"
            >
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </select>
          </div>

          <div className="flex flex-wrap gap-3 pt-2">
            <button
              type="submit"
              disabled={loading}
              className="rounded-xl bg-black px-4 py-2 text-white text-sm font-semibold hover:opacity-90 disabled:opacity-50"
            >
              {loading ? "Saving..." : "Save"}
            </button>

            <button
              type="button"
              className="rounded-xl border px-4 py-2 text-sm font-semibold hover:bg-gray-50"
              onClick={() => navigate("/admin/cms-pages")}
            >
              Cancel
            </button>
          </div>
        </form>
      )}
    </div>
  );
}
